var map = {
	"./airtime.png": "96c5",
	"./bg_color - Copy.png": "8421",
	"./bg_color.png": "c1e2",
	"./dstv.png": "167c",
	"./g-play-old.png": "f45a",
	"./g-play.png": "aa93",
	"./gotv.png": "d1c2",
	"./kplc-postpaid.png": "0ad2",
	"./logo.png": "ede7",
	"./ms.logo.png": "6726",
	"./newlogo.png": "3559",
	"./play.png": "2f89",
	"./postk.png": "cb74",
	"./start.png": "8ad8",
	"./tokens.png": "297d",
	"./tokenz.png": "b206",
	"./trans - Copy.png": "646e",
	"./trans.png": "fd40",
	"./trans~~.png": "3f09",
	"./water.png": "4f68",
	"./zuku.png": "5233"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1638";